<template>
        <el-dialog
                        title="制定临时任务"
                        width="80%"
                        top="60px"
                        :bottom="0"
                        append-to-body
                         style="max-hight:100vh;margin-bottom:0"
                        v-if="dialogVisible"
                        :fullscreen="dialogFull"
                        :close-on-click-modal="false"
                        :visible.sync="dialogVisible"
                        :destroy-on-close="true"
                        class="taskManagement-addForm"
                >
                <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        查看车位组在场车辆
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>

                        </div>
                </template>
                <div style="max-height:calc(100vh - 350px);overflow:scroll;">

                  <el-form :inline="true" ref="query" :model="query" style="    overflow: hidden;">
                    <el-row :gutter="24">
                      <el-col span="6" >
                        <el-form-item label="车牌号:" prop="plateNumber">
                          <input v-model="query.plateNumber" style="width: 100%;" placeholder="请输入车牌号"></input>
                        </el-form-item>
                      </el-col>
                      <el-col span="18" style="text-align:right;">
                        <el-form-item>
                          <el-button type="primary" size="small" icon="el-icon-search" @click="selectCarInByGroup" >搜 索</el-button>
                          <el-button type="default" size="small" icon="el-icon-delete" @click="searchCarInReset">清 空</el-button>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>

                        <avue-crud
                                :option="option"
                                :table-loading="loading"
                                :data="data"
                                :page.sync="page"
                                :permission="permissionList"
                                :before-open="beforeOpen"
                                v-model="form"
                                v-if="dialogVisible"
                                ref="crud"
                                @current-change="currentChange"
                                @size-change="sizeChange"

                        >
                        </avue-crud>
                </div>
        </el-dialog>
</template>
<script>
import {
  getCarInGroupByPlateNumber,
  selectCarInByGroup,

} from '@/api/v4ward/carv2/carinoutinfo';
export default {
        data(){
                return{
                  carGroupId:'',
                  plateNUmber:'',
                        dialogVisible:false,
                        dialogFull:false,
                        loading:false,
                        page:{
                                size: 10,
                                current: 1,
                                total: 0,
                        },
                        option:{
                                height: 'auto',
                                searchShow: true,
                                searchMenuSpan: 4,

                                calcHeight: 'auto',
                                tip: false,
                                border: true,
                                index: true,
                                align: 'center',
                                viewBtn: false,
                                selection: false,
                                addBtn: false,
                                menu: false,
                                menuWidth: 100,
                                columnBtn: false,
                                refreshBtn: false,
                                stripe:true,
                                column: [
                                        {
                                                label: '停车场',
                                                type: 'tree',
                                                prop: 'spaceName',

                                        },

                                        {
                                                label: '区域',
                                                prop: 'regionName',
                                                span: 12,
                                        },
                                        {
                                                label: '车位组名称',
                                                prop: 'carParkGroupName',
                                                width: 150,
                                        },
                                        {
                                                label: '车位数',
                                                prop: 'carParkNumber',
                                                width: 100,
                                                searchSpan: 5,
                                        },
                                        {
                                                label: '车牌号',
                                                prop: 'plateNumber',
                                                width: 100,
                                                searchSpan: 5,
                                        },
                                        {
                                                label: '车辆类型',
                                                prop: 'carType',
                                                width: 100,
                                        },
                                        {
                                                label: '入场时间',
                                                prop: 'inTime',
                                                searchSpan: 9,
                                                width: 150,
                                                type: 'datetime',
                                                format: 'yyyy-MM-dd HH:mm:ss',
                                                valueFormat: 'yyyy-MM-dd HH:mm:ss',
                                        },

                                        {
                                                label: '入场通道名称',
                                                prop: 'inPassageName',
                                        },
                                ],
                        },
                        query:{}

                }

        },
        created(){
                this.option.height = this.bodyHeight - 700;
        },
        methods:{
                openDialog(row){
                        this.query.spaceId = row.spaceId;
                        this.query.regionId = row.regionId;
                        this.query.carNo = row.carNo;

                        this.loading = true;
                        this.onLoad();
                        this.page = {
                                size: 10,
                                current: 1,
                                total: 0,
                        }
                },
                currentChange(currentPage) {
                        this.page.current = currentPage;
                        this.onLoad()
                },
                sizeChange(pageSize) {
                        this.page.size = pageSize;
                        this.onLoad()
                },
          searchCarInReset(){
            this.page.currentPage = 1;
            this.query.plateNumber = '';
            this.query.carGroupId = this.carGroupId;
            this.selectCarInByGroup();
          },
          selectCarInByGroup(page){
            this.loading = true;
            this.query.carNo = this.query.plateNumber;
            this.query.carGroupId = this.carGroupId;
            page = page || this.page;
            selectCarInByGroup({...this.query,...this.page}).then(res=>{
              this.data = res.data.records;
              this.page.total = res.data.total;
              this.page.current = res.data.current;
              this.loading = false;
              this.dialogVisible = true;
            }).catch(res=>{
              this.data = [];

              this.page.current = 1;

              this.loading = false;
            })
          },
                onLoad(page) {
                        this.loading = true;
                        page = page || this.page;
                        getCarInGroupByPlateNumber({...this.query,...this.page}).then(res=>{
                                this.data = res.data.records;
                                this.page.total = res.data.total;
                                this.page.current = res.data.current;
                                this.loading = false;
                                this.dialogVisible = true;
                          if(this.data){
                            this.carGroupId = this.data[0].carGroupId;
                          }
                        }).catch(res=>{
                                this.data = [];

                                this.page.current = 1;

                                this.loading = false;
                        })
                }

        }
}
</script>
<style lang="scss" >
.taskManagement-addForm{
        .avue-dialog__footer{
                display: flex;
                justify-content:flex-end;
        }
        .el-form-item__error{
                position: relative;
        }
        // .taskContentLabel::before{
        //         content: " * ";
        //         color: #f00;
        // }

}

</style>
